import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardContent } from '@material-ui/core';
import { Visibility, Delete } from '@material-ui/icons';
import { getAllMediasForProject, deleteMedia } from '../../../redux/actions/project';
import DeleteDialog from '../../../components/DeleteDialog';
import NewMedia from '../NewMedia';
import '../../Drawings/List/drawingList.scss';

const { REACT_APP_API: url } = process.env;

const List = ({ projectId }) => {
  const dispatch = useDispatch();
  const { media } = useSelector(({ projects }) => projects);
  const [isNewOpen, setIsNewOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState('');

  useEffect(() => {
    dispatch(getAllMediasForProject(projectId));
  }, []);

  const onView = (path) => {
    window.open(`${url}media/${path}`, '_blank');
  };

  return (
    <Card className="drawinglist">
      <CardContent>
        <div className="userlist__header" style={{ marginBottom: 16 }}>
          <Button size="medium" color="primary" variant="contained" onClick={() => setIsNewOpen(true)}>
            Upload Media
          </Button>
        </div>
        <div className="drawinglist__drawing">
          {media?.map((item) => (
            <div className="drawinglist__drawing-item" key={item.id}>
              <span>{item.name}</span>
              <Visibility onClick={() => onView(item.path)} style={{ cursor: 'pointer' }} />
              <Delete
                onClick={() => {
                  setSelectedId(item.id);
                  setIsDeleteOpen(true);
                }}
                style={{ color: 'red', cursor: 'pointer' }}
              />
            </div>
          ))}
          {media?.length === 0 && <span>No media found</span>}
        </div>
      </CardContent>

      <DeleteDialog
        open={isDeleteOpen}
        handleClose={() => {
          setIsDeleteOpen(false);
          setSelectedId('');
        }}
        handleOk={() => {
          dispatch(deleteMedia(selectedId));
          setIsDeleteOpen(false);
          setSelectedId('');
        }}
        message="Are you sure you want to delete this media?"
      />
      {isNewOpen && (
        <NewMedia
          projectId={projectId}
          open={isNewOpen}
          handleClose={() => setIsNewOpen(false)}
          handleOk={() => setIsNewOpen(false)}
        />
      )}
    </Card>
  );
};

List.propTypes = {
  projectId: PropTypes.number.isRequired
};

export default List;
